import { render, staticRenderFns } from "./WsBottomNav.vue?vue&type=template&id=54c34093&"
import script from "./WsBottomNav.vue?vue&type=script&lang=js&"
export * from "./WsBottomNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports